import { render } from "./FormListVueModal.vue?vue&type=template&id=73ad2d73"
import script from "./FormListVueModal.js?vue&type=script&lang=js"
export * from "./FormListVueModal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__